import { RouterModule, Routes } from '@angular/router';

const prototypeRoutes: Routes = [
  {
    path: 'prototype',
    loadChildren: () =>
      import('./pricing/pricing.module').then((m) => m.PrototypeProduct),
  },
];
export default prototypeRoutes;
